(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["content-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('content-tabs')) {
    customElements.define(
      'content-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('[data-tablist]');
          this.tabs = Array.from(this.querySelectorAll(':scope > .content-tabs__panels > .content-tab > [role="tab"]'));
          this.panels = this.tabs.map((tab) => document.getElementById(tab.getAttribute('aria-controls')));
          this.tabs.forEach((tab, i) => {
            this.list.append(tab);
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => this.onKey(e, i));
          });
          this.select(0, false);

          if (window.Shopify?.designMode) {
            this.addEventListener('shopify:block:select', (e) => {
              const i = this.panels.findIndex((panel) => panel?.closest('.content-tab')?.contains(e.target));
              if (i > -1) this.select(i, false);
            });
          }
        }

        select(index, focus = true) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            if (this.panels[i]) this.panels[i].hidden = !active;
          });
          if (focus) this.tabs[index]?.focus();
        }

        onKey(e, i) {
          const last = this.tabs.length - 1;
          const next = { ArrowRight: i === last ? 0 : i + 1, ArrowLeft: i === 0 ? last : i - 1, Home: 0, End: last }[e.key];
          if (next === undefined) return;
          e.preventDefault();
          this.select(next);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('countdown-timer')) {
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        this.nums = {};
        this.querySelectorAll('[data-unit]').forEach((el) => (this.nums[el.dataset.unit] = el));
        this.hasDays = Boolean(this.nums.days);
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      target() {
        if (this.dataset.mode === 'daily') {
          const end = new Date();
          end.setHours(24, 0, 0, 0);
          return end.getTime();
        }
        const raw = (this.dataset.end || '').trim().replace(' ', 'T');
        const time = Date.parse(raw);
        return Number.isNaN(time) ? null : time;
      }

      tick() {
        const end = this.target();
        if (end === null) return;
        const diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (diff === 0) return this.expire();

        const pad = (n) => String(n).padStart(2, '0');
        const days = Math.floor(diff / 86400);
        const hours = Math.floor(diff / 3600) - (this.hasDays ? days * 24 : 0);
        const minutes = Math.floor((diff % 3600) / 60);
        const seconds = diff % 60;
        if (this.nums.days) this.nums.days.textContent = pad(days);
        this.nums.hours.textContent = pad(hours);
        this.nums.minutes.textContent = pad(minutes);
        this.nums.seconds.textContent = pad(seconds);
      }

      expire() {
        clearInterval(this.timer);
        if (window.Shopify?.designMode) return;
        const message = this.querySelector('.countdown__expired');
        if (this.dataset.expired === 'hide') {
          this.hidden = true;
        } else if (message) {
          this.querySelector('.countdown__clock').hidden = true;
          message.hidden = false;
        }
      }
    }
    customElements.define('countdown-timer', CountdownTimer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["order-tracking"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('order-tracking')) {
    customElements.define(
      'order-tracking',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.input = this.querySelector('input[name="tracking"]');
          this.error = this.querySelector('.order-tracking__error');
          this.form?.addEventListener('submit', this.onSubmit);
          this.input?.addEventListener('input', () => this.showError(false));
        }

        onSubmit = (event) => {
          event.preventDefault();
          // Allow several numbers separated by commas, spaces or new lines.
          const numbers = this.input.value
            .split(/[\s,;]+/)
            .map((n) => n.trim().toUpperCase())
            .filter((n) => /^[A-Z0-9-]{5,40}$/.test(n));
          const pattern = this.dataset.pattern || '';
          if (!numbers.length || !pattern.includes('{tracking}')) return this.showError(true);
          const url = pattern.replace('{tracking}', numbers.map(encodeURIComponent).join(','));
          if (this.hasAttribute('data-new-tab')) window.open(url, '_blank', 'noopener');
          else window.location.href = url;
        };

        showError(show) {
          if (!this.error) return;
          this.error.hidden = !show;
          this.input.toggleAttribute('aria-invalid', show);
          if (show) this.input.focus();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["shipping-note"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('shipping-note')) {
    customElements.define(
      'shipping-note',
      class extends HTMLElement {
        connectedCallback() {
          const text = this.querySelector('.shipping-note__text');
          if (!text || !text.innerHTML.includes('[date]')) return;
          const date = new Date();
          date.setDate(date.getDate() + Number(this.dataset.days || 0));
          const label = date.toLocaleDateString(document.documentElement.lang || undefined, { month: 'short', day: 'numeric' });
          text.innerHTML = text.innerHTML.replaceAll('[date]', label);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["steps"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__stepsProgress) return;
    window.__stepsProgress = true;

    // Fills each step's connector and marks a step reached once its marker passes 60% of the viewport.
    const update = () => {
      const trigger = window.innerHeight * 0.6;
      document.querySelectorAll('.steps--progress').forEach((list) => {
        list.querySelectorAll(':scope > .step').forEach((step) => {
          const marker = step.querySelector('.step__marker');
          if (!marker) return;
          const top = marker.getBoundingClientRect().top;
          const rect = step.getBoundingClientRect();
          step.classList.toggle('is-reached', top < trigger);
          const fill = Math.min(1, Math.max(0, (trigger - top) / Math.max(1, rect.bottom - top)));
          step.style.setProperty('--fill', fill.toFixed(3));
        });
      });
    };

    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        update();
      });
    };
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
    else update();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-slideshow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('video-slideshow')) {
    customElements.define(
      'video-slideshow',
      class extends HTMLElement {
        connectedCallback() {
          this.videos = Array.from(this.querySelectorAll('video'));
          if (!this.videos.length) return;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.autoplay = this.hasAttribute('data-autoplay') && !reduce;

          this.videos.forEach((video) => {
            video.muted = true;
            video.playsInline = true;
            video.loop = true;
            video.addEventListener('play', () => this.sync(video));
            video.addEventListener('pause', () => this.sync(video));
          });

          if (this.autoplay) {
            this.io = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  const video = entry.target;
                  if (entry.intersectionRatio >= 0.6 && !video.dataset.userPaused) video.play().catch(() => {});
                  else if (entry.intersectionRatio < 0.6) video.pause();
                });
              },
              { threshold: [0, 0.6, 1] }
            );
            this.videos.forEach((video) => this.io.observe(video));
          }

          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          this.io?.disconnect();
          this.removeEventListener('click', this.onClick);
        }

        onClick = (event) => {
          const slide = event.target.closest('.video-slide');
          const video = slide?.querySelector('video');
          if (!video) return;

          if (event.target.closest('[data-video-sound]')) {
            const unmute = video.muted;
            this.videos.forEach((v) => {
              v.muted = true;
              this.sync(v);
            });
            video.muted = !unmute;
            if (unmute && video.paused) video.play().catch(() => {});
            this.sync(video);
            return;
          }

          if (event.target.closest('[data-video-toggle]')) {
            if (video.paused) {
              delete video.dataset.userPaused;
              video.play().catch(() => {});
            } else {
              video.dataset.userPaused = 'true';
              video.pause();
            }
          }
        };

        sync(video) {
          const slide = video.closest('.video-slide');
          if (!slide) return;
          slide.toggleAttribute('data-playing', !video.paused);
          slide.toggleAttribute('data-sound', !video.muted);
          slide.querySelector('[data-video-sound]')?.setAttribute('aria-pressed', String(!video.muted));
          slide.querySelector('[data-video-toggle]')?.setAttribute('aria-pressed', String(!video.paused));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
